// src/tileset-manager/utils/bound-buffer.ts
import { bBoxToBounds, boundsContains, padBounds } from "../../geo";
var getLatLonBoundsBuffer = (latLonBounds, bufferRatio) => {
  const bounds = bBoxToBounds(latLonBounds);
  const newBounds = padBounds(bounds, bufferRatio);
  const maxLngExtent = 360 * 3 - 180;
  const maxLatExtent = 85.0511287798065;
  const latLonBoundsBuffer = [
    Math.max(newBounds[0][0], -maxLngExtent),
    Math.max(newBounds[0][1], -maxLatExtent),
    Math.min(newBounds[1][0], maxLngExtent),
    Math.min(newBounds[1][1], maxLatExtent)
  ];
  return latLonBoundsBuffer;
};
var isLatLonBoundsContains = (latLonBoundsBuffer, latLonBounds) => {
  const boundsBuffer = bBoxToBounds(latLonBoundsBuffer);
  const bounds = bBoxToBounds(latLonBounds);
  const isContains = boundsContains(boundsBuffer, bounds);
  return isContains;
};
export {
  getLatLonBoundsBuffer,
  isLatLonBoundsContains
};
